import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "../../mixins/infoList";
import { getChannelListWithPage, createChannel, updateChannel } from "@/api/channel";
export default {
  name: "channelConfig",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getChannelListWithPage,
      searchInfo: {
        channel_id: "",
        channel_name: ""
      },
      dialogVisible: false,
      dialogTitle: "",
      isEdit: false,
      formData: {
        channel_id: "",
        channel_name: ""
      },
      formRules: {
        channel_id: [{
          required: true,
          message: "请输入渠道ID",
          trigger: "blur"
        }],
        channel_name: [{
          required: true,
          message: "请输入渠道名称",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.queryData();
  },
  methods: {
    queryData: function queryData() {
      this.getTableData();
    },
    openCreateDialog: function openCreateDialog() {
      var _this = this;
      this.dialogTitle = "新增渠道";
      this.isEdit = false;
      this.formData = {
        channel_id: "",
        channel_name: ""
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        if (_this.$refs.channelForm) {
          _this.$refs.channelForm.clearValidate();
        }
      });
    },
    openEditDialog: function openEditDialog(row) {
      var _this2 = this;
      this.dialogTitle = "编辑渠道";
      this.isEdit = true;
      this.formData = {
        channel_id: row.channel_id,
        channel_name: row.channel_name
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        if (_this2.$refs.channelForm) {
          _this2.$refs.channelForm.clearValidate();
        }
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.$refs.channelForm.validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (valid) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return");
                      case 2:
                        if (!_this3.isEdit) {
                          _context.next = 8;
                          break;
                        }
                        _context.next = 5;
                        return updateChannel(_this3.formData);
                      case 5:
                        res = _context.sent;
                        _context.next = 11;
                        break;
                      case 8:
                        _context.next = 10;
                        return createChannel(_this3.formData);
                      case 10:
                        res = _context.sent;
                      case 11:
                        if (res.code === 0) {
                          _this3.$message({
                            message: _this3.isEdit ? "修改成功" : "新增成功",
                            type: "success"
                          });
                          _this3.dialogVisible = false;
                          _this3.getTableData();
                        }
                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};